export const REDUCER_KEY_SIMILARITY_SEARCH = 'similaritySearch';

export const CLEAN_STATE = 'rs/similaritySearch/CLEAN_STATE';

export const SIMILARITY_SEARCH = 'rs/similaritySearch/SIMILARITY_SEARCH';
export const SIMILARITY_SEARCH_SUCCESS = 'rs/similaritySearch/SIMILARITY_SEARCH_SUCCESS';
export const SIMILARITY_SEARCH_FAILURE = 'rs/similaritySearch/SIMILARITY_SEARCH_FAILURE';

export const LOAD_SIMILARITY_SEARCH_RESULTS = 'rs/similaritySearch/LOAD_SIMILARITY_SEARCH_RESULTS';
export const LOAD_SIMILARITY_SEARCH_RESULTS_SUCCESS = 'rs/similaritySearch/LOAD_SIMILARITY_SEARCH_RESULTS_SUCCESS';
export const LOAD_SIMILARITY_SEARCH_RESULTS_FAILURE = 'rs/similaritySearch/LOAD_SIMILARITY_SEARCH_RESULTS_FAILURE';

export const SUBMIT_SIMILAR_SUBSTANCE = 'rs/similaritySearch/SUBMIT_SIMILAR_SUBSTANCE';
export const SUBMIT_SIMILAR_SUBSTANCE_SUCCESS = 'rs/similaritySearch/SUBMIT_SIMILAR_SUBSTANCE_SUCCESS';
export const SUBMIT_SIMILAR_SUBSTANCE_FAILURE = 'rs/similaritySearch/SUBMIT_SIMILAR_SUBSTANCE_FAILURE';